import { styled } from '@uhg-abyss/web/tools/styled';
import { Card } from '@uhg-abyss/web/ui/Card';

export const ListItem = styled('ul', {
  listStyle: 'disc',
  marginLeft: '28px',
  fontSize: '$md',
  color: '$core.color.neutral.90',
  marginTop: '16px',
  marginBottom: '0px',
  fontWeight: 'normal',
  '@media (max-width: 464px)': { fontSize: '16px' },
  '& li > span': { display: 'flex', gap: '8px', marginBottom: '10px' },
  '& li::marker': { fontSize: '14px' },
  '& li b': { fontWeight: 'normal' },
});

export const VirtualVisitLogo = styled('div', {
  marginTop: '20px',
  width: '270px',
  height: '220px',
  borderRadius: '50%',
  overflow: 'hidden',
});

export const costStyle = {
  'abyss-text-root': {
    fontSize: '25.63px',
    fontWeight: 'bold',
    marginTop: '12px',
    fontFamily: '$primary',
    color: '$core.color.brand.100',
  },
};

export const virtualVisitDescription = {
  'abyss-text-root': {
    fontSize: '$lg',
    lineHeight: '24px',
    color: '$core.color.neutral.90',
    fontWeight: 400,
    '@media (min-width: 745px)': {
      margin: '$md 0',
    },
    '@media (max-width: 744px)': {
      marginTop: '16px',
    },
    wordWrap: 'word-break',
  },
};

export const virtualVisitDescriptionCard = {
  'abyss-text-root': {
    fontSize: '$sm',
    fontWeight: 'bold',
    color: '$core.color.neutral.90',
  },
};

export const availableProviderHeadingStyle = {
  'abyss-heading-root': {
    '@media (min-width: 745px)': {
      marginTop: '18px',
    },
    '@media (max-width: 744px)': {
      marginTop: '12px',
    },
  },
};

export const StyledVirtualUrgentCareSpan = styled('span', {
  color: '#002677',
  fontSize: '25.63px',
  fontWeight: '700',
  lineHeight: '32px',
  wordWrap: 'break-word',
});

export const StyledYouPay = styled('span', {
  color: '#323333',
  fontSize: '14px',
  fontFamily: '$primary',
  fontWeight: '700',
  lineHeight: '18px',
  wordWrap: 'break-word',
});

export const StyledClaimsSpan01 = styled('span', {
  color: '#002677',
  fontSize: '20px',
  fontFamily: 'SF Pro',
  fontWeight: '700',
  lineHeight: '24px',
  wordWrap: 'break-word',
});

export const StyledClaimsSpan02 = styled('span', {
  color: '#002677',
  fontSize: '28px',
  fontFamily: '$heading',
  fontWeight: '600',
  lineHeight: '32px',
  wordWrap: 'break-word',
});

export const StyledClaims = styled('span', {
  color: '#4B4D4F',
  fontSize: '12px',
  fontFamily: '$primary',
  fontWeight: '500',
  lineHeight: '16px',
  wordWrap: 'break-word',
});

export const StyledFrame204977607 = styled('div', {
  height: '31px',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: '4px',
  display: 'flex',
});

export const StyledFrame2147227429 = styled('div', {
  height: '37px',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: '8px',
  display: 'inline-flex',
});

// for get cost estimate link

export const StyledLink = styled('div', {
  height: '24px',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: '4px',
  display: 'inline-flex',
  textDecoration: 'none',
});

export const StyledLeftIconAndLink = styled('div', {
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: '4px',
  display: 'flex',
  cursor: 'pointer',
});

export const StyledTextLabelGetCost = styled('a', {
  dynamic: ({ cssProps: { disabled } = {} }) => ({
    color: disabled ? 'gray' : '#196ECF',
    '&:hover, &:focus': {
      textDecoration: disabled ? 'none' : 'underline',
      color: disabled ? 'gray' : '#196ECF',
    },
  }),
  color: '',
  fontSize: '16px',
  fontFamily: '$primary',
  fontWeight: '600',
  lineHeight: '20px',
  wordWrap: 'break-word',
});

export const VirtualCareHeader = styled('div', {
  alignSelf: 'stretch',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: '48px',
  display: 'inline-flex',
  width: '100%',
  paddingRight: '5%',
});

export const StyledVirtualPrimaryCareSpan = styled('span', {
  color: '#002677',
  fontSize: '25.63px',
  fontWeight: '700',
  lineHeight: '32px',
  wordWrap: 'break-word',
});
export const VirtualSpecialtyCareHeader = styled('div', {
  alignSelf: 'stretch',
  alignItems: 'center',
  gap: '48px',
  display: 'inline-flex',
  width: '100%',
  paddingRight: '5%',
});

export const virtualSpecialtyCareHeaderDescription = {
  'abyss-text-root': {
    fontSize: '$lg',
    lineHeight: '24px',
    color: '$core.color.neutral.90',
    fontWeight: 400,
    '@media (min-width: 745px)': {
      marginTop: '16px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    '@media (max-width: 744px)': {
      marginTop: '16px',
      fontSize: '$md',
      lineHeight: '20px',
      whiteSpace: 'normal',
      wordWrap: 'break-word',
    },
  },
};

export const StyledVirtualSpecialtyCard = styled(Card, {
  minWidth: '384px',
  '@media (max-width: 464px)': {
    minWidth: '318px',
  },
  display: 'flex',
  height: '100%',
  borderRadius: '12px',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  padding: '16px',
  gap: '16px',
  marginTop: '0px !important',
  overflow: 'hidden',
  border: '0.5px solid #CBCCCD',
  boxShadow: '0 4px 4px -2px rgba(0, 0, 0, 0.16)',
  background: '#fff',
  '& > div:first-of-type': {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
    justifyContent: 'space-between',
  },
});

export const StyledVirtualSpecialtyCardSection = styled('div', {
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  gap: '16px',
});

export const VirtualSectionWrap = styled('div', {
  display: 'flex',
  marginTop: '8px',
  '@media (max-width: 984px)': {
    marginTop: '$sm',
  },
  '@media (max-width: 464px)': {
    marginTop: '$md',
    paddingLeft: '16px',
    paddingRight: '16px',
  },
});

export const StyledCardWrapper = styled('div', {
  width: '100%',
  '& .abyss-card-root': {
    '@media (max-width: 744px)': {
      width: '100% !important',
      maxWidth: 'none !important',
    },
  },
});

export const VirtualCareHeaderContainer = styled('div', {
  flexDirection: 'row',
  display: 'flex',
  alignItems: 'center',
  '@media (max-width: 744px)': {
    width: '60% !important',
  },
});
